module.exports = __webpack_public_path__ + "static/media/assa-off-app-provider-icon.af17d5b0.svg";